import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  FuelSupplierGetRecord,
  AddFuelSupplierRequest,
  FuelSupplierAddRecord,
  AddFuelSupplierContactRequest,
  UpdateFuelSupplierRequest,
  UpdateFuelSupplierContactRequest,
  DeleteFuelSupplierContactRequest,
} from '../types';

@Injectable({
  providedIn: 'root',
})
export class FuelSupplierService {
  private readonly baseUrl = '/api/fuel-supplier';

  constructor(private http: HttpClient) {}

  // GET /api/fuel-supplier
  getFuelSuppliers(): Observable<FuelSupplierGetRecord[]> {
    return this.http.get<FuelSupplierGetRecord[]>(`${this.baseUrl}`);
  }

  getFuelSupplierById(fuelSupplierId: number): Observable<FuelSupplierGetRecord[]> {
    return this.http.get<FuelSupplierGetRecord[]>(`${this.baseUrl}`, {
      params: { fuelSupplierId: fuelSupplierId.toString() }
    });
  }

  getFuelSuppliersForInquiry(): Observable<FuelSupplierGetRecord[]> {
    return this.http.get<FuelSupplierGetRecord[]>(`${this.baseUrl}/for-inquiry`);
  }

  // POST /api/fuel-supplier/add
  addFuelSupplier(request: AddFuelSupplierRequest): Observable<FuelSupplierAddRecord> {
    return this.http.post<FuelSupplierAddRecord>(`${this.baseUrl}/add`, request);
  }

  // POST /api/fuel-supplier/add-contacts
  addFuelSupplierContacts(request: AddFuelSupplierContactRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/add-contacts`, request);
  }

  // PUT /api/fuel-supplier/update
  updateFuelSupplier(request: UpdateFuelSupplierRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update`, request);
  }

  // PUT /api/fuel-supplier/update-contacts
  updateFuelSupplierContacts(request: UpdateFuelSupplierContactRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update-contacts`, request);
  }

  // DELETE /api/fuel-supplier/delete-contacts
  deleteFuelSupplierContacts(request: DeleteFuelSupplierContactRequest): Observable<void> {
    return this.http.request<void>('delete', `${this.baseUrl}/delete-contacts`, {
      body: request,
    });
  }
}
